import { render, staticRenderFns } from "./editGroupModal.vue?vue&type=template&id=93f2ddda&scoped=true&lang=html&"
import script from "./editGroupModal.vue?vue&type=script&lang=js&"
export * from "./editGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./editGroupModal.vue?vue&type=style&index=0&id=93f2ddda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f2ddda",
  null
  
)

export default component.exports